module.exports = __webpack_public_path__ + "assets/img/zpfh.a7de9b4d.png";